// extracted by mini-css-extract-plugin
export default {"container":"error-screen_container__B5Qrp"};